module.exports = __webpack_public_path__ + "static/media/impact1.db06d2c4.ogg";